<template>
  <ButtonTertiary
    class="font-regular"
    :class="buttonClass"
    @click="$emit('onClick')"
  >
    <slot />
  </ButtonTertiary>
</template>

<script>
export default {
  name: 'ToggleToken',
  props: {
    is_toggled: { type: Boolean },
    color: { type: String, default: '!bg-primary-500 !text-white' },
    is_background_transparent: { type: Boolean },
  },

  emits: ['onClick'],

  computed: {
    buttonClass() {
      if (this.is_toggled) {
        return `${this.color}`;
      }
      if (this.is_background_transparent) {
        return '!bg-transparent';
      }
      return '';
    },
  },
};
</script>
